import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../services/api";

export const useRemoveDistributerUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id) => {
      const res = await api.delete(`/distributors/user/delete/${id}`);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['viewDistributorUsers']);
    },
  });
};